export var MONS_CUSTOMER_ID_HEADER = "_debug_amz-mons-customer";
export var MONS_CUSTOMER_ID_SESSION = "monsCustomerId";
export var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

//# sourceMappingURL=requestHeaderConfig.js.map